import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { CrudEndpoints, EditorDefinition, IsEmail, IdItemModel, ItemModelDefinition, Trim, ItemModelProp, ModelId } from '@core/shared/model';
import { Expose } from 'class-transformer-global-storage';
import { MinLength } from 'class-validator';
import { DemoRequestRestraints } from './demo-request.restraints';
import { ContactSource } from '../enum';
let DemoRequestItem = /*#__PURE__*/(() => {
  let DemoRequestItem = class DemoRequestItem extends IdItemModel {
    // Alias | optional | Most items have a name to make them identifyable by humans.
    // @Expose()
    // @Default('')
    // alias:string;
    toString() {
      return "DemoAnfrage " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], DemoRequestItem.prototype, "creationDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], DemoRequestItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), MinLength(3, {
    message: 'Bitte geben Sie Ihren vollständigen Namen an!'
  }), __metadata("design:type", String)], DemoRequestItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), MinLength(3, {
    message: 'Bitte geben Sie den Namen des Unternehmens / der Einrichtung an!'
  }), __metadata("design:type", String)], DemoRequestItem.prototype, "company", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), IsEmail(), __metadata("design:type", String)], DemoRequestItem.prototype, "email", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], DemoRequestItem.prototype, "phone", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], DemoRequestItem.prototype, "message", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), Trim(), __metadata("design:type", String)], DemoRequestItem.prototype, "source", void 0);
  DemoRequestItem = __decorate([EditorDefinition(['name', 'company', 'email', 'phone', 'source', 'message'], {
    useCrudEndpoint: 'public'
  }), EditorDefinition('admin', ['name', 'company', 'email', 'phone', 'source', 'message'], {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    public: '/contact/demo-request',
    admin: '/admin/contact/demo-request'
  }), UseRestraints(DemoRequestRestraints), ItemModelDefinition({
    texts: {
      item: 'Demoanfrage',
      items: 'Demoanfragen'
    }
  }), ModelId("DemoRequestItem") // auto-generated by generate-model-ids
  ], DemoRequestItem);
  return DemoRequestItem;
})();
export { DemoRequestItem };